import { render, staticRenderFns } from "./main.vue?vue&type=template&id=b8e83d6e"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=b8e83d6e&prod&lang=postcss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TechSupportForm: require('/usr/src/app/components/panel/issues/TechSupportForm.vue').default,S2BaseModal: require('/usr/src/app/node_modules/front-components/components/common/modals/BaseModal.vue').default,AppHeader: require('/usr/src/app/components/layout/AppHeader.vue').default,NavTabs: require('/usr/src/app/components/layout/NavTabs.vue').default,AgencyPageHeader: require('/usr/src/app/components/layout/AgencyPageHeader.vue').default,S2FeedbackToast: require('/usr/src/app/node_modules/front-components/components/ui/notification/FeedbackToast.vue').default})
